/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Alert,
  Tabs,
  Tab,
  InputGroup,
} from 'react-bootstrap';
import {
  FaDownload,
  FaSearch,
  FaUsers,
  FaBuilding,
  FaDesktop,
  FaTicketAlt,
  FaTrophy,
  FaRedo,
} from 'react-icons/fa';
import moment from 'moment';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SearchableSelect from '../../components/SearchableSelect';
import axios from '../../services/axios';
import Breadcrumbs from '../../components/Breadcrumbs';
import PageHeader from '../../components/PageHeader';
import Loading from '../../components/Loading';
import ErrorProcessor from '../../components/ErrorProcessor';
import DataTable from '../../components/DataTable';
import { exportToExcel } from '../../utils/exportUtils';
import { useNotification } from '../../components/Notification/NotificationContext';

// Componente para renderizar lista de clientes
function ClientsList({ value }) {
  if (!Array.isArray(value)) {
    console.warn('ClientsList received non-array value:', value);
    return <div>Nenhum cliente disponível</div>;
  }
  return (
    <div>
      {value.slice(0, 3).map((client, index) => (
        <div
          key={client.id || `client-${index}`}
          style={{ fontSize: '0.85em' }}
        >
          {client.name || client.companyName || 'N/A'}
        </div>
      ))}
      {value.length > 3 && (
        <div style={{ fontSize: '0.8em', color: '#666' }}>
          +{value.length - 3} mais...
        </div>
      )}
    </div>
  );
}

// Componente para formatar data
function DateFormatter({ value }) {
  return value ? moment(value).format('DD/MM/YYYY HH:mm') : 'N/A';
}

// Componente para exibir medalhas de ranking
function RankingMedal({ position, medal }) {
  const getMedalStyle = (medal) => {
    switch (medal) {
      case '🥇':
        return { color: '#FFD700', fontSize: '1.5em', fontWeight: 'bold' };
      case '🥈':
        return { color: '#C0C0C0', fontSize: '1.3em', fontWeight: 'bold' };
      case '🥉':
        return { color: '#CD7F32', fontSize: '1.1em', fontWeight: 'bold' };
      default:
        return { fontSize: '1em' };
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={getMedalStyle(medal)}>{medal}</span>
      <span style={{ fontWeight: 'bold' }}>{position}º</span>
    </div>
  );
}

// Colunas para tabela de clientes
const clientsColumns = [
  {
    Header: 'Mesa de Serviço',
    accessor: (row) => row.serviceDeskName || 'N/A', // Fallback para evitar undefined
  },
  {
    Header: 'Total de Clientes',
    accessor: (row) => row.totalClients || 0,
  },
  {
    Header: 'Clientes',
    accessor: 'clients',
    Cell: ({ value }) => <ClientsList value={value || []} />, // Garante que value seja array
  },
];

// Colunas para tabela de atendentes
const attendantsColumns = [
  { Header: 'Atendente', accessor: (row) => row.attendantName || 'N/A' },
  { Header: 'Email', accessor: (row) => row.attendantEmail || 'N/A' },
  { Header: 'Total', accessor: (row) => row.totalTickets || 0 },
  { Header: 'Abertos', accessor: (row) => row.openTickets || 0 },
  { Header: 'Fechados', accessor: (row) => row.closedTickets || 0 },
  { Header: 'Pausados', accessor: (row) => row.pausedTickets || 0 },
  { Header: 'Em Atendimento', accessor: (row) => row.inProgressTickets || 0 },
];

// Colunas para tabela de tickets
const ticketsColumns = (handleReopenTicket) => [
  {
    Header: 'ID',
    accessor: 'id',
    Cell: ({ value }) => (
      <a
        href={`/tickets/${value}/edit`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    ),
  },
  {
    Header: 'Título',
    accessor: 'title',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Cliente',
    accessor: (row) => (row.Customer && row.Customer.name) || 'N/A',
  },
  {
    Header: 'Atendente',
    accessor: (row) => (row.AssignedUser && row.AssignedUser.name) || 'N/A',
  },
  {
    Header: 'Mesa de Serviço',
    accessor: (row) => (row.ServiceDesk && row.ServiceDesk.name) || 'N/A',
  },
  {
    Header: 'Departamento',
    accessor: (row) => (row.Department && row.Department.name) || 'N/A',
  },
  {
    Header: 'Data Criação',
    accessor: 'created_at',
    Cell: ({ value }) => <DateFormatter value={value} />,
  },
  {
    Header: 'Data Fechamento',
    accessor: 'closed_at',
    Cell: ({ value }) => (value ? <DateFormatter value={value} /> : 'N/A'),
  },
];

const ticketsColumnsUnified = (handleReopenTicket) => [
  {
    Header: 'N° Ticket',
    accessor: 'id',
    Cell: ({ value }) => (
      <Link
        to={`/tickets/${value}/edit`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#007bff', textDecoration: 'none' }}
        onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
        onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
      >
        {value || 'N/A'}
      </Link>
    ),
  },
  {
    Header: 'Título',
    accessor: 'title',
    Cell: ({ value }) => value || 'N/A',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ value }) => value || 'N/A',
  },
  {
    Header: 'Origem',
    accessor: 'origem',
    Cell: ({ value }) => value || '—',
  },
  {
    Header: 'Protocolo',
    accessor: 'protocolNumber',
    Cell: ({ value }) => value || '—',
  },
  {
    Header: 'Cliente',
    accessor: 'customer.name',
    Cell: ({ value, row }) => {
      const { customer } = row.original;
      return customer && customer.name ? customer.name : 'N/A';
    },
  },
  {
    Header: 'Solicitante',
    accessor: 'requester.name',
    Cell: ({ value, row }) => {
      const { requester } = row.original;
      return requester && requester.name ? requester.name : 'N/A';
    },
  },
  {
    Header: 'Atendente',
    accessor: 'assignedUser.name',
    Cell: ({ value, row }) => {
      const { assignedUser } = row.original;
      return assignedUser && assignedUser.name
        ? assignedUser.name
        : 'Não atribuído';
    },
  },
  {
    Header: 'Fila (Mesa de Serviço)',
    accessor: 'serviceDesk.name',
    Cell: ({ value, row }) => {
      const { serviceDesk } = row.original;
      return serviceDesk && serviceDesk.name ? serviceDesk.name : 'N/A';
    },
  },
  {
    Header: 'Departamento',
    accessor: 'department.name',
    Cell: ({ value, row }) => {
      const { department } = row.original;
      return department && department.name ? department.name : 'N/A';
    },
  },
  {
    Header: 'Data de Criação',
    accessor: 'createdAt',
    Cell: ({ value }) => <DateFormatter value={value} />,
  },
  {
    Header: 'Início Atendimento',
    accessor: 'startTime',
    Cell: ({ value }) =>
      value ? moment(value).format('DD/MM/YYYY HH:mm') : 'Não iniciado',
  },
  {
    Header: 'Fechamento',
    accessor: 'closingTime',
    Cell: ({ value }) =>
      value ? moment(value).format('DD/MM/YYYY HH:mm') : 'Ainda aberto',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
    Cell: ({ row }) => {
      const ticket = row.original;
      return ticket.status === 'fechado' ? (
        <Button
          variant="outline-success"
          size="sm"
          onClick={() => handleReopenTicket(ticket.id)}
          title="Reabrir Ticket"
        >
          <FaRedo /> Reabrir
        </Button>
      ) : null;
    },
  },
];

export default function NewReports() {
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState(null);
  const [activeTab, setActiveTab] = useState('clients-servicedesk');
  const showNotification = useNotification();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Estados para dados auxiliares
  const [serviceDesks, setServiceDesks] = useState([]);
  const [attendants, setAttendants] = useState([]);
  const [departments, setDepartments] = useState([]);

  // Estados para filtros
  const [dateRange, setDateRange] = useState({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().endOf('day').format('YYYY-MM-DD'),
  });
  const [selectedServiceDesk, setSelectedServiceDesk] = useState('');
  const [selectedAttendant, setSelectedAttendant] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('Todos');
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('todos');
  const [selectedOrigem, setSelectedOrigem] = useState('');
  const [origensOptions, setOrigensOptions] = useState([]);
  // Protocolo do atendimento no chat, para o supervisor auditar o ticket.
  const [selectedProtocol, setSelectedProtocol] = useState('');

  // Estados para dados dos relatórios
  const [clientsData, setClientsData] = useState([]);
  const [attendantsData, setAttendantsData] = useState([]);
  const [ticketsData, setTicketsData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [rankingData, setRankingData] = useState([]);

  // Estados para busca de tickets
  const [customers, setCustomers] = useState([]);
  const [requesters, setRequesters] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedRequester, setSelectedRequester] = useState('');
  // Filtro de cliente específico para a aba Relatório de Tickets
  const [selectedTicketsCustomer, setSelectedTicketsCustomer] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTicketTitle, setSelectedTicketTitle] = useState('');
  const [selectedTicketNumber, setSelectedTicketNumber] = useState('');
  const [customerTickets, setCustomerTickets] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);

  // Função para reabrir ticket
  const handleReopenTicket = async (ticketId) => {
    try {
      await axios.put(`/tickets/${ticketId}`, { status: 'aberto' });
      showNotification('Ticket reaberto com sucesso!', 'success');

      // Atualizar a lista de tickets
      setTicketsData((prevData) =>
        prevData.map((ticket) =>
          ticket.id === ticketId ? { ...ticket, status: 'aberto' } : ticket
        )
      );

      // Atualizar também os resultados de busca se existirem
      setSearchResults((prevResults) =>
        prevResults.map((ticket) =>
          ticket.id === ticketId ? { ...ticket, status: 'aberto' } : ticket
        )
      );

      // Redirecionar para a página de edição do ticket
      navigate(`/tickets/${ticketId}/edit`);
    } catch (error) {
      console.error('Erro ao reabrir ticket:', error);
      showNotification('Erro ao reabrir o ticket', 'error');
    }
  };

  // Colunas para tabela de relatório por status
  const statusColumns = [
    {
      Header: 'Status',
      accessor: (row) => row.status || 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Tickets',
      accessor: (row) => row.quantidade || 0,
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Percentual de Aproveitamento',
      accessor: (row) => {
        // Encontrar a quantidade de tickets criados (abertos) e fechados no período
        const ticketsCriados =
          (statusData.find((item) => item.status === 'Abertos') || {})
            .quantidade || 0;
        const ticketsFechados =
          (statusData.find((item) => item.status === 'Fechados') || {})
            .quantidade || 0;

        let percentual = 0;

        if (row.status === 'Abertos') {
          // Tickets que permaneceram abertos: 100% - percentual de fechados
          if (ticketsCriados > 0) {
            const percentualFechados = (ticketsFechados / ticketsCriados) * 100;
            percentual = Math.max(0, 100 - percentualFechados).toFixed(1);
          } else {
            percentual = '0.0';
          }
        } else if (row.status === 'Fechados') {
          // Tickets fechados: percentual de resolução baseado nos criados
          if (ticketsCriados > 0) {
            percentual = Math.min(
              100,
              (ticketsFechados / ticketsCriados) * 100
            ).toFixed(1);
          } else {
            // Se não há tickets criados, mas há fechados, são tickets de períodos anteriores
            percentual = ticketsFechados > 0 ? 'N/A' : '0.0';
          }
        }

        return typeof percentual === 'string' && percentual !== 'N/A'
          ? `${percentual}%`
          : percentual === 'N/A'
            ? 'N/A'
            : `${percentual}%`;
      },
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
  ];

  // Colunas para tabela de ranking
  const rankingColumns = [
    {
      Header: 'Posição',
      accessor: (row) => row.position || 0,
      Cell: ({ row }) => (
        <RankingMedal
          position={row.original.position}
          medal={row.original.medal || ''}
        />
      ),
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Atendente',
      accessor: (row) => row.attendantName || 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Email',
      accessor: (row) => row.attendantEmail || 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Tickets Fechados',
      accessor: (row) => row.closedTickets || 0,
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center', fontWeight: 'bold', color: '#28a745' },
    },
    {
      Header: 'Total de Tickets',
      accessor: (row) => row.totalTickets || 0,
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Taxa de Resolução',
      accessor: (row) => `${row.resolutionRate || 0}%`,
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center', fontWeight: 'bold' },
    },
  ];

  // Colunas para tabela de busca de tickets
  const searchTicketsColumns = [
    {
      Header: 'ID',
      accessor: (row) => row.id || 'N/A',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center', fontWeight: 'bold' },
      Cell: ({ row }) => (
        <Link
          to={`/tickets/${row.original.id}/edit`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            color: '#007bff',
            fontWeight: 'bold',
          }}
        >
          {row.original.id || 'N/A'}
        </Link>
      ),
    },
    {
      Header: 'Título',
      accessor: (row) => row.title || 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Status',
      accessor: (row) => row.status || 'N/A',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Origem',
      accessor: (row) => row.origem || '—',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Protocolo',
      accessor: (row) => row.protocolNumber || '—',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Cliente',
      accessor: (row) =>
        row.customer && row.customer.name ? row.customer.name : 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Solicitante',
      accessor: (row) =>
        row.requester && row.requester.name ? row.requester.name : 'N/A',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Atendente',
      accessor: (row) =>
        row.assignedUser && row.assignedUser.name
          ? row.assignedUser.name
          : 'Não atribuído',
      headerStyle: { textAlign: 'left' },
      style: { textAlign: 'left' },
    },
    {
      Header: 'Data de Criação',
      accessor: (row) =>
        row.createdAt
          ? moment(row.createdAt).format('DD/MM/YYYY HH:mm')
          : 'N/A',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      Header: 'Ações',
      accessor: 'actions',
      headerStyle: { textAlign: 'center' },
      style: { textAlign: 'center' },
      Cell: ({ row }) => {
        const ticket = row.original;
        return ticket.status === 'fechado' ? (
          <Button
            variant="outline-success"
            size="sm"
            onClick={() => handleReopenTicket(ticket.id)}
            title="Reabrir Ticket"
          >
            <FaRedo /> Reabrir
          </Button>
        ) : null;
      },
    },
  ];

  // Buscar dados auxiliares
  const fetchAuxiliaryData = useCallback(async () => {
    try {
      const [
        serviceDesksResponse,
        attendantsResponse,
        departmentsResponse,
        origensResponse,
      ] = await Promise.all([
        axios.get('/servicedesks'),
        axios.get('/profiles'),
        axios.get('/departaments'),
        axios.get('/ticket-origins'),
      ]);
      setServiceDesks(
        Array.isArray(serviceDesksResponse.data)
          ? serviceDesksResponse.data
          : []
      );
      setAttendants(
        Array.isArray(attendantsResponse.data) ? attendantsResponse.data : []
      );
      setDepartments(
        Array.isArray(departmentsResponse.data) ? departmentsResponse.data : []
      );
      setOrigensOptions(
        Array.isArray(origensResponse.data) ? origensResponse.data : []
      );
    } catch (err) {
      setApiErrors(err);
      console.error('Error fetching auxiliary data:', err);
    }
  }, []);

  useEffect(() => {
    fetchAuxiliaryData();
  }, [fetchAuxiliaryData]);

  // Função para buscar relatório de clientes por mesa de serviços
  const fetchClientsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/relatorios/clients-by-servicedesk');
      const data = Array.isArray(response.data)
        ? response.data.map((item) => ({
            ...item,
            clients: Array.isArray(item.clients) ? item.clients : [], // Garante que clients seja array
          }))
        : [];
      setClientsData(data);
      console.log('clientsData set:', data);
    } catch (err) {
      setApiErrors(err);
      setClientsData([]);
      console.error('Error fetching clients report:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Função para buscar relatório de atendentes
  const fetchAttendantsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/relatorios/attendants', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
        },
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setAttendantsData(data);
      console.log('attendantsData set:', data);
    } catch (err) {
      setApiErrors(err);
      setAttendantsData([]);
      console.error('Error fetching attendants report:', err);
    } finally {
      setIsLoading(false);
    }
  }, [dateRange]);

  // Função para buscar relatório de tickets
  const fetchTicketsReport = useCallback(
    async (endpoint, params = {}) => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/relatorios/${endpoint}`, {
          params: {
            startDate: dateRange.start,
            endDate: dateRange.end,
            status: selectedStatus,
            ...params,
          },
        });
        const data = Array.isArray(response.data)
          ? response.data.map((item) => ({
              ...item,
              AssignedUser: item.AssignedUser || {},
              Customer: item.Customer || {},
              ServiceDesk: item.ServiceDesk || {},
              Department: item.Department || {},
            }))
          : [];
        setTicketsData(data);
        console.log('ticketsData set:', data);
      } catch (err) {
        setApiErrors(err);
        setTicketsData([]);
        console.error(`Error fetching tickets report (${endpoint}):`, err);
      } finally {
        setIsLoading(false);
      }
    },
    [dateRange, selectedStatus]
  );

  // Função para buscar relatório unificado de tickets
  const fetchUnifiedTicketsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {
        startDate: dateRange.start,
        endDate: dateRange.end,
        status: selectedStatus !== 'Todos' ? selectedStatus : undefined,
        attendantId: selectedAttendant || undefined,
        departmentId: selectedDepartment || undefined,
        serviceDeskId: selectedServiceDesk || undefined,
        customerId: selectedTicketsCustomer || undefined,
        origem: selectedOrigem || undefined,
        protocolNumber: selectedProtocol.trim() || undefined,
      };

      // Remove parâmetros undefined
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await axios.get('/relatorios/tickets-unified', {
        params,
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setTicketsData(data);
      console.log('unified ticketsData set:', data);
    } catch (err) {
      setApiErrors(err);
      setTicketsData([]);
      console.error('Error fetching unified tickets report:', err);
    } finally {
      setIsLoading(false);
    }
  }, [
    dateRange,
    selectedStatus,
    selectedAttendant,
    selectedDepartment,
    selectedServiceDesk,
    selectedTicketsCustomer,
    selectedOrigem,
    selectedProtocol,
  ]);

  useEffect(() => {
    const spStart = searchParams.get('start');
    const spEnd = searchParams.get('end');
    const spStatus = searchParams.get('status');
    const spAttendant = searchParams.get('attendantId');
    const spDepartment = searchParams.get('departmentId');
    const spServiceDesk = searchParams.get('serviceDeskId');
    if (spStart || spEnd) {
      setDateRange((prev) => ({
        start: spStart || prev.start,
        end: spEnd || prev.end,
      }));
    }
    if (spStatus) setSelectedStatus(spStatus);
    if (spAttendant) setSelectedAttendant(spAttendant);
    if (spDepartment) setSelectedDepartment(spDepartment);
    if (spServiceDesk) setSelectedServiceDesk(spServiceDesk);
  }, []);

  useEffect(() => {
    const params = {};
    params.start = dateRange.start;
    params.end = dateRange.end;
    if (selectedStatus !== 'Todos') params.status = selectedStatus;
    if (selectedAttendant) params.attendantId = selectedAttendant;
    if (selectedDepartment) params.departmentId = selectedDepartment;
    if (selectedServiceDesk) params.serviceDeskId = selectedServiceDesk;
    setSearchParams(params);
  }, [
    dateRange,
    selectedStatus,
    selectedAttendant,
    selectedDepartment,
    selectedServiceDesk,
  ]);

  // Função para buscar relatório por status
  const fetchStatusReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {
        startDate: dateRange.start,
        endDate: dateRange.end,
        status: selectedStatusFilter,
      };

      const response = await axios.get('/relatorios/tickets-by-status', {
        params,
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setStatusData(data);
      console.log('statusData set:', data);
    } catch (err) {
      setApiErrors(err);
      setStatusData([]);
      console.error('Error fetching status report:', err);
    } finally {
      setIsLoading(false);
    }
  }, [dateRange, selectedStatusFilter]);

  // Função para buscar ranking de atendentes
  const fetchRankingReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/relatorios/ranking-attendants', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
        },
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setRankingData(data);
      console.log('rankingData set:', data);
    } catch (err) {
      setApiErrors(err);
      setRankingData([]);
      console.error('Error fetching ranking report:', err);
    } finally {
      setIsLoading(false);
    }
  }, [dateRange]);

  // Função para controlar a alteração das datas
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  // Função para exportar dados
  const handleExport = (data, filename) => {
    if (!Array.isArray(data) || data.length === 0) {
      alert('Não há dados para exportar');
      return;
    }
    exportToExcel(data, filename);
  };

  // Preparar dados para exportação de clientes
  const prepareClientsExportData = () => {
    const exportData = [];
    if (!Array.isArray(clientsData)) {
      console.warn('clientsData is not an array:', clientsData);
      return exportData;
    }
    clientsData.forEach((desk) => {
      if (!Array.isArray(desk.clients)) {
        console.warn(
          `desk.clients is not an array for ${desk.serviceDeskName}:`,
          desk.clients
        );
        return;
      }
      desk.clients.forEach((client) => {
        exportData.push({
          'Mesa de Serviço': desk.serviceDeskName || 'N/A',
          'Descrição da Mesa': desk.serviceDeskDescription || 'N/A',
          Cliente: client.name || client.companyName || 'N/A',
          Email: client.email || 'N/A',
          Telefone: client.phone || 'N/A',
        });
      });
    });
    return exportData;
  };

  // Preparar dados para exportação de atendentes
  const prepareAttendantsExportData = () => {
    if (!Array.isArray(attendantsData)) {
      console.warn('attendantsData is not an array:', attendantsData);
      return [];
    }
    return attendantsData.map((attendant) => ({
      Atendente: attendant.attendantName || 'N/A',
      Email: attendant.attendantEmail || 'N/A',
      'Total de Tickets': attendant.totalTickets || 0,
      'Tickets Abertos': attendant.openTickets || 0,
      'Tickets Fechados': attendant.closedTickets || 0,
      'Tickets Pausados': attendant.pausedTickets || 0,
      'Tickets em Atendimento': attendant.inProgressTickets || 0,
    }));
  };

  // Preparar dados para exportação de tickets
  const prepareTicketsExportData = () => {
    if (!Array.isArray(ticketsData)) {
      console.warn('ticketsData is not an array:', ticketsData);
      return [];
    }
    return ticketsData.map((ticket) => ({
      N_Ticket: ticket.id || 'N/A',
      Titulo: ticket.title || 'N/A',
      Atendente:
        ticket.assignedUser && ticket.assignedUser.name
          ? ticket.assignedUser.name
          : 'Não atribuído',
      DATA_CRIACAO: ticket.createdAt
        ? moment(ticket.createdAt).format('DD/MM/YYYY HH:mm:ss')
        : 'N/A',
      INICIO_ATENDIMENTO: ticket.startTime
        ? moment(ticket.startTime).format('DD/MM/YYYY HH:mm:ss')
        : 'Não iniciado',
      FIM_ATENDIMENTO: ticket.closingTime
        ? moment(ticket.closingTime).format('DD/MM/YYYY HH:mm:ss')
        : 'Ainda aberto',
      STATUS_TICKET: ticket.status || 'N/A',
      ORIGEM: ticket.origem || 'N/A',
      PROTOCOLO_CHAT: ticket.protocolNumber || 'N/A',
      SOLICITANTE:
        ticket.requester && ticket.requester.name
          ? ticket.requester.name
          : 'N/A',
      FILA_ATENDIMENTO:
        ticket.serviceDesk && ticket.serviceDesk.name
          ? ticket.serviceDesk.name
          : 'N/A',
      CLIENTE:
        ticket.customer && ticket.customer.name ? ticket.customer.name : 'N/A',
    }));
  };

  // Preparar dados para exportação de status
  const prepareStatusExportData = () => {
    if (!Array.isArray(statusData)) {
      console.warn('statusData is not an array:', statusData);
      return [];
    }
    const total = statusData.reduce(
      (sum, item) => sum + (item.quantidade || 0),
      0
    );
    return statusData.map((item) => ({
      Status: item.status || 'N/A',
      Tickets: item.quantidade || 0,
      Percentual:
        total > 0 ? `${((item.quantidade / total) * 100).toFixed(1)}%` : '0%',
    }));
  };

  // Preparar dados para exportação de ranking
  const prepareRankingExportData = () => {
    if (!Array.isArray(rankingData)) {
      console.warn('rankingData is not an array:', rankingData);
      return [];
    }
    return rankingData.map((attendant) => ({
      Posição: attendant.position || 'N/A',
      Atendente: attendant.name || 'N/A',
      Email: attendant.email || 'N/A',
      'Tickets Fechados': attendant.closedTickets || 0,
      'Total de Tickets': attendant.totalTickets || 0,
      'Taxa de Resolução': attendant.resolutionRate
        ? `${attendant.resolutionRate}%`
        : '0%',
    }));
  };

  // Funções para busca de tickets
  // ✅ FUNÇÃO OTIMIZADA: Buscar apenas nomes dos clientes
  const fetchCustomers = useCallback(async () => {
    try {
      const response = await axios.get('/customers/names-only');
      const data = Array.isArray(response.data) ? response.data : [];
      setCustomers(data);
    } catch (err) {
      console.error('Error fetching customers:', err);
      setCustomers([]);
    }
  }, []);

  // ✅ FUNÇÃO OTIMIZADA: Buscar solicitantes por cliente específico
  const fetchRequesters = useCallback(async (customerId) => {
    try {
      const response = await axios.get(`/requesters/by-customer/${customerId}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setRequesters(data);
    } catch (err) {
      console.error('Error fetching requesters:', err);
      setRequesters([]);
    }
  }, []);

  // ✅ FUNÇÃO: Buscar tickets de um cliente específico
  const fetchCustomerTickets = useCallback(async (customerId) => {
    try {
      const response = await axios.get(`/tickets/recent/${customerId}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setCustomerTickets(data);
    } catch (err) {
      console.error('Error fetching customer tickets:', err);
      setCustomerTickets([]);
    }
  }, []);

  // ✅ FUNÇÃO OTIMIZADA: Buscar tickets com filtros otimizados
  const searchTickets = useCallback(async () => {
    try {
      setIsLoading(true);
      setHasSearched(true);

      const params = {};

      if (selectedCustomer) {
        params.customerId = selectedCustomer;
      }

      if (selectedRequester) {
        params.requesterId = selectedRequester;
      }

      // Se o usuário digitou no campo "Número do Ticket"
      if (selectedTicketNumber && selectedTicketNumber.trim()) {
        const cleanNumber = selectedTicketNumber.trim().replace(/^open/i, '');
        const formattedId = `Open${cleanNumber}`;
        params.ticketId = formattedId;
        params.searchTerm = formattedId;
      }

      // Se o usuário digitou no campo "Título do Ticket"
      if (selectedTicketTitle && selectedTicketTitle.trim()) {
        params.title = selectedTicketTitle.trim();
      }

      // Termo genérico se nada acima tiver sido especificado
      if (
        !params.ticketId &&
        !params.title &&
        searchTerm &&
        searchTerm.trim()
      ) {
        params.searchTerm = searchTerm.trim();
      }

      const response = await axios.get('/relatorios/search-tickets', {
        params: {
          ...params,
          limit: 20, // Definir limite de 20 registros por página
        },
      });
      const data = (response.data && response.data.tickets) || [];
      setSearchResults(data);

      if (data.length === 0) {
        showNotification(
          'Nenhum ticket encontrado com os filtros aplicados.',
          'info'
        );
      } else {
        showNotification(`Encontrados ${data.length} ticket(s).`, 'success');
      }
    } catch (err) {
      console.error('Error searching tickets:', err);
      setSearchResults([]);
      showNotification('Erro ao buscar tickets. Tente novamente.', 'error');
    } finally {
      setIsLoading(false);
    }
  }, [
    selectedCustomer,
    selectedRequester,
    searchTerm,
    selectedTicketTitle,
    selectedTicketNumber,
    showNotification,
  ]);

  const clearSearch = useCallback(() => {
    setSelectedCustomer('');
    setSelectedRequester('');
    setSearchTerm('');
    setSelectedTicketTitle('');
    setSelectedTicketNumber('');
    setCustomerTickets([]);
    setSearchResults([]);
    setRequesters([]);
    setHasSearched(false);
  }, []);

  // Carregar clientes quando as abas de busca ou relatório de tickets forem ativadas
  useEffect(() => {
    if (
      (activeTab === 'search-tickets' || activeTab === 'tickets-unified') &&
      customers.length === 0
    ) {
      fetchCustomers();
    }
  }, [activeTab, customers.length, fetchCustomers]);

  return (
    <Container fluid>
      <Breadcrumbs />
      <PageHeader title="Relatórios Avançados" />

      {apiErrors && <ErrorProcessor errors={apiErrors} />}

      <Card>
        <Card.Header>
          <h5 className="mb-0">Relatórios do Sistema</h5>
        </Card.Header>
        <Card.Body>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            {/* Aba: Clientes por Mesa de Serviços */}
            <Tab
              eventKey="clients-servicedesk"
              title={
                <>
                  <FaUsers className="me-2" />
                  Clientes por Mesa
                </>
              }
            >
              <Row className="mb-3">
                <Col md={6}>
                  <Alert variant="info">
                    <strong>Relatório de Clientes por Mesa de Serviços</strong>
                    <br />
                    Visualize todos os clientes associados a cada mesa de
                    serviços.
                  </Alert>
                </Col>
                <Col md={6} className="text-end">
                  <Button
                    variant="primary"
                    onClick={fetchClientsReport}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Carregando...' : 'Gerar Relatório'}
                  </Button>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleExport(
                        prepareClientsExportData(),
                        'clientes-por-mesa-servicos'
                      )
                    }
                    disabled={clientsData.length === 0}
                  >
                    <FaDownload className="me-2" />
                    Exportar XLSX
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : clientsData.length === 0 ? (
                <Alert variant="warning">
                  Nenhum dado disponível. Clique em "Gerar Relatório" para
                  carregar os dados.
                </Alert>
              ) : (
                <>
                  {console.log(
                    'Rendering clients-servicedesk with clientsData:',
                    clientsData
                  )}
                  <DataTable
                    columns={clientsColumns}
                    items={clientsData}
                    pagination
                    searchable
                  />
                </>
              )}
            </Tab>

            {/* Aba: Relatório de Atendentes */}
            <Tab
              eventKey="attendants"
              title={
                <>
                  <FaUsers className="me-2" />
                  Atendentes
                </>
              }
            >
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Data Início</Form.Label>
                    <Form.Control
                      type="date"
                      name="start"
                      value={dateRange.start}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Data Fim</Form.Label>
                    <Form.Control
                      type="date"
                      name="end"
                      value={dateRange.end}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className="d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={fetchAttendantsReport}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Carregando...' : 'Gerar Relatório'}
                  </Button>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleExport(
                        prepareAttendantsExportData(),
                        'relatorio-atendentes'
                      )
                    }
                    disabled={attendantsData.length === 0}
                  >
                    <FaDownload className="me-2" />
                    Exportar XLSX
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : attendantsData.length === 0 ? (
                <Alert variant="warning">
                  Nenhum dado disponível. Clique em "Gerar Relatório" para
                  carregar os dados.
                </Alert>
              ) : (
                <>
                  {console.log(
                    'Rendering attendants with attendantsData:',
                    attendantsData
                  )}
                  <DataTable
                    columns={attendantsColumns}
                    items={attendantsData}
                    pagination
                    searchable
                  />
                </>
              )}
            </Tab>

            {/* Aba: Relatório de Tickets */}
            <Tab
              eventKey="tickets-unified"
              title={
                <>
                  <FaTicketAlt className="me-2" />
                  Relatório de Tickets
                </>
              }
            >
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Início</Form.Label>
                    <Form.Control
                      type="date"
                      name="start"
                      value={dateRange.start}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Fim</Form.Label>
                    <Form.Control
                      type="date"
                      name="end"
                      value={dateRange.end}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Cliente</Form.Label>
                    <SearchableSelect
                      options={customers}
                      value={selectedTicketsCustomer}
                      onChange={(val) => setSelectedTicketsCustomer(val)}
                      placeholder="Pesquisar cliente..."
                      displayKey={(c) =>
                        c.nomeEmpresa || c.razaoSocial || c.name || 'N/A'
                      }
                      valueKey="id"
                      maxHeight="250px"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Atendente</Form.Label>
                    <Form.Select
                      value={selectedAttendant}
                      onChange={(e) => setSelectedAttendant(e.target.value)}
                    >
                      <option value="">Todos os atendentes</option>
                      {attendants.map((attendant) => (
                        <option
                          key={attendant.user_id}
                          value={attendant.user_id}
                        >
                          {attendant.name || attendant.email || 'N/A'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Departamento</Form.Label>
                    <Form.Select
                      value={selectedDepartment}
                      onChange={(e) => setSelectedDepartment(e.target.value)}
                    >
                      <option value="">Todos os departamentos</option>
                      {departments.map((dept) => (
                        <option key={dept.id} value={dept.id}>
                          {dept.name || 'N/A'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Mesa de Serviço</Form.Label>
                    <Form.Select
                      value={selectedServiceDesk}
                      onChange={(e) => setSelectedServiceDesk(e.target.value)}
                    >
                      <option value="">Todas as mesas</option>
                      {serviceDesks.map((desk) => (
                        <option key={desk.id} value={desk.id}>
                          {desk.name || 'N/A'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      <option value="Todos">Todos</option>
                      <option value="aberto">Aberto</option>
                      <option value="fechado">Fechado</option>
                      <option value="pausado">Pausado</option>
                      <option value="em_atendimento">Em Atendimento</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Origem</Form.Label>
                    <Form.Select
                      value={selectedOrigem}
                      onChange={(e) => setSelectedOrigem(e.target.value)}
                    >
                      <option value="">Todas as origens</option>
                      {origensOptions.map((o) => (
                        <option key={o.id} value={o.name}>
                          {o.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Protocolo do chat</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedProtocol}
                      onChange={(e) => setSelectedProtocol(e.target.value)}
                      placeholder="PROT-..."
                    />
                  </Form.Group>
                </Col>
                <Col
                  md={6}
                  className="d-flex align-items-end justify-content-end"
                >
                  <Button
                    variant="primary"
                    onClick={fetchUnifiedTicketsReport}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Carregando...' : 'Gerar Relatório'}
                  </Button>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleExport(
                        prepareTicketsExportData(),
                        'relatorio-tickets'
                      )
                    }
                    disabled={ticketsData.length === 0}
                  >
                    <FaDownload className="me-2" />
                    Exportar XLSX
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : ticketsData.length === 0 ? (
                <Alert variant="warning">
                  Nenhum dado disponível. Clique em "Gerar Relatório" para
                  carregar os dados.
                </Alert>
              ) : (
                <>
                  {console.log(
                    'Rendering tickets-unified with ticketsData:',
                    ticketsData
                  )}
                  <DataTable
                    columns={ticketsColumnsUnified(handleReopenTicket)}
                    items={ticketsData}
                    pagination
                    searchable
                    defaultPageSize={20}
                  />
                </>
              )}
            </Tab>

            {/* Aba: Relatório por Status */}
            <Tab
              eventKey="tickets-status"
              title={
                <>
                  <FaTicketAlt className="me-2" />
                  Tickets por Status
                </>
              }
            >
              <Row className="mb-3">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Início</Form.Label>
                    <Form.Control
                      type="date"
                      name="start"
                      value={dateRange.start}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Fim</Form.Label>
                    <Form.Control
                      type="date"
                      name="end"
                      value={dateRange.end}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      value={selectedStatusFilter}
                      onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    >
                      <option value="todos">Todos</option>
                      <option value="abertos">Abertos</option>
                      <option value="fechados">Fechados</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3} className="d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={fetchStatusReport}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Carregando...' : 'Gerar'}
                  </Button>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleExport(
                        prepareStatusExportData(),
                        'relatorio-por-status'
                      )
                    }
                    disabled={statusData.length === 0}
                  >
                    <FaDownload className="me-2" />
                    Exportar XLSX
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : statusData.length === 0 ? (
                <Alert variant="warning">
                  Nenhum dado disponível. Clique em "Gerar" para carregar os
                  dados.
                </Alert>
              ) : (
                <>
                  <Alert variant="info">
                    <p>
                      <strong>Relatório por Status:</strong> Mostra a quantidade
                      de tickets agrupados por status no período selecionado.
                    </p>
                  </Alert>
                  <DataTable
                    columns={statusColumns}
                    items={statusData}
                    pagination
                    searchable
                    defaultPageSize={20}
                  />
                </>
              )}
            </Tab>

            {/* Aba: Ranking de Atendentes */}
            <Tab
              eventKey="ranking-attendants"
              title={
                <>
                  <FaTrophy className="me-2" />
                  Ranking de Atendentes
                </>
              }
            >
              <Row className="mb-3">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Início</Form.Label>
                    <Form.Control
                      type="date"
                      name="start"
                      value={dateRange.start}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Data Fim</Form.Label>
                    <Form.Control
                      type="date"
                      name="end"
                      value={dateRange.end}
                      onChange={handleDateChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={3} className="d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={fetchRankingReport}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Carregando...' : 'Gerar Ranking'}
                  </Button>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleExport(
                        prepareRankingExportData(),
                        'ranking-atendentes'
                      )
                    }
                    disabled={rankingData.length === 0}
                  >
                    <FaDownload className="me-2" />
                    Exportar XLSX
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : rankingData.length === 0 ? (
                <Alert variant="warning">
                  Nenhum dado disponível. Clique em "Gerar Ranking" para
                  carregar os dados.
                </Alert>
              ) : (
                <>
                  <Alert variant="info">
                    <p>
                      <strong>Ranking de Atendentes:</strong> Mostra o ranking
                      dos atendentes baseado na quantidade de tickets fechados
                      no período selecionado.
                      <br />
                      <strong>Tickets Fechados:</strong> Apenas tickets com
                      status "fechado" no período selecionado.
                      <br />
                      <strong>Total de Tickets:</strong> TODOS os tickets
                      atribuídos ao atendente no período selecionado.
                    </p>
                  </Alert>
                  <DataTable
                    columns={rankingColumns}
                    items={rankingData}
                    pagination
                    searchable
                    defaultPageSize={20}
                  />
                </>
              )}
            </Tab>

            {/* Aba: Buscar Tickets */}
            <Tab
              eventKey="search-tickets"
              title={
                <>
                  <FaTicketAlt className="me-2" />
                  Buscar Tickets
                </>
              }
            >
              <Row className="mb-3">
                <Col md={12}>
                  <Alert variant="info">
                    <strong>Buscar Tickets</strong>
                    <br />
                    Use os filtros abaixo para buscar tickets específicos. Você
                    pode filtrar por cliente, solicitante e/ou buscar por título
                    ou número do ticket.
                  </Alert>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Cliente</Form.Label>
                    <SearchableSelect
                      options={customers.map((customer) => ({
                        id: customer.id,
                        name:
                          customer.label ||
                          customer.razaoSocial ||
                          customer.nomeEmpresa ||
                          'N/A',
                      }))}
                      value={selectedCustomer}
                      onChange={(value) => {
                        setSelectedCustomer(value);
                        setSelectedRequester('');
                        setSelectedTicketTitle('');
                        setSelectedTicketNumber('');
                        setRequesters([]);
                        setCustomerTickets([]);
                        if (value) {
                          fetchRequesters(value);
                          fetchCustomerTickets(value);
                        }
                      }}
                      placeholder="Digite para pesquisar cliente..."
                      displayKey="name"
                      valueKey="id"
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Solicitante</Form.Label>
                    <SearchableSelect
                      options={requesters.map((requester) => ({
                        id: requester.id,
                        name: requester.name,
                      }))}
                      value={selectedRequester}
                      onChange={(value) => setSelectedRequester(value)}
                      placeholder={
                        selectedCustomer
                          ? 'Digite para pesquisar solicitante...'
                          : 'Selecione um cliente para filtrar solicitante...'
                      }
                      displayKey="name"
                      valueKey="id"
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Título do Ticket</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite para pesquisar por título..."
                      value={selectedTicketTitle}
                      onChange={(e) => setSelectedTicketTitle(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          searchTickets();
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Número do Ticket</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>Open</InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="12345"
                        value={selectedTicketNumber}
                        onChange={(e) => {
                          const val = e.target.value.replace(/^open/i, '');
                          setSelectedTicketNumber(val);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchTickets();
                          }
                        }}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={12} className="text-start">
                  <Button
                    variant="primary"
                    onClick={searchTickets}
                    disabled={isLoading}
                    className="me-2"
                  >
                    <FaSearch className="me-2" />
                    {isLoading ? 'Buscando...' : 'Buscar Tickets'}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={clearSearch}
                    disabled={isLoading}
                  >
                    <FaRedo className="me-2" />
                    Limpar
                  </Button>
                </Col>
              </Row>

              {isLoading ? (
                <Loading />
              ) : searchResults.length === 0 && hasSearched ? (
                <Alert variant="warning">
                  Nenhum ticket encontrado com os filtros aplicados.
                </Alert>
              ) : searchResults.length > 0 ? (
                <>
                  <Alert variant="success">
                    Encontrados {searchResults.length} ticket(s) com os filtros
                    aplicados.
                  </Alert>
                  <DataTable
                    columns={searchTicketsColumns}
                    items={searchResults}
                    pagination
                    searchable
                    defaultPageSize={20}
                  />
                </>
              ) : (
                <Alert variant="info">
                  Digite o número do ticket, título, cliente ou solicitante e
                  clique em "Buscar Tickets" para ver os resultados.
                </Alert>
              )}
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </Container>
  );
}
